import { ApiModel } from "./api-model";
import { Language } from "./language";

export class DataDuplicateLanguage extends ApiModel {
  languageToDuplicate: Language;
  languages: Language[];

  get languagesString() {
    return this.languages.map((l) => l.value).join(", ");
  }

  constructor(data: any) {
    super(data);
    if (data) {
      this.languages = data.map((language) => new Language(language));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/dataDuplicateLanguage.ts